// extracted by mini-css-extract-plugin
export default {"step_box":"ArrayInfo_step_box__fTRa4"};